export default __webpack_public_path__ + "static/i3-13786bca07367987278a6f5ac4e367f7.png";